import { RI_BREAKDOWNS } from 'frontend-utils/utils/constants/constant-values';
import type HotelAndMarketService from 'lumen/services/hotel-and-market';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getDateRange(
  fromDate: string | null | undefined,
  toDate: string | null | undefined,
  hotelAndMarketService: HotelAndMarketService,
  stayDateFilter = '',
) {
  let dateRangeStart = fromDate
    ? hotelAndMarketService.toLocalTime(fromDate).format('YYYY-MM-DD')
    : hotelAndMarketService
        .getLocalTime()
        .startOf('month')
        .format('YYYY-MM-DD');
  let dateRangeEnd = toDate
    ? hotelAndMarketService.toLocalTime(toDate).format('YYYY-MM-DD')
    : hotelAndMarketService.getLocalTime().endOf('month').format('YYYY-MM-DD');

  // The difference (in days) between the fromDate and (the first day of) the stay date filter
  let stayDateFilterOffset = 0;

  if (stayDateFilter) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsedStayDateFilter = JSON.parse(stayDateFilter);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (parsedStayDateFilter[RI_BREAKDOWNS.IMPACT_DATE]) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const dividerIndex =
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        parsedStayDateFilter[RI_BREAKDOWNS.IMPACT_DATE][0].indexOf(':');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
      const startDate = parsedStayDateFilter[
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        RI_BREAKDOWNS.IMPACT_DATE
      ][0].substring(0, dividerIndex);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
      const endDate = parsedStayDateFilter[
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        RI_BREAKDOWNS.IMPACT_DATE
      ][0].substring(dividerIndex + 1);
      stayDateFilterOffset = hotelAndMarketService
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        .toLocalTime(startDate)
        .diff(dateRangeStart, 'day');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      dateRangeStart = startDate;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      dateRangeEnd = endDate;
    }
  }

  return {
    dateRangeStart,
    dateRangeEnd,
    stayDateFilterOffset,
  };
}
